import * as Yup from 'yup';

export default Yup.object().shape({
  name: Yup.string()
    .required('You must enter a  name')
    .min(2, 'Name must 2 or more characters')
    .max(35, 'Name must be less than 35 characters'),
  description: Yup.string()
    .required('You must enter a description')
    .min(2, 'Description must 2 or more characters')
    .max(75, 'Description must be at less than 75 characters long'),
  checkType: Yup.string().required('You must select the check type option'),
});
